/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".responsive[_ngcontent-%COMP%]{width:100%;height:auto;max-height:800px;max-width:1000px;display:block;margin-right:auto;margin-left:auto}"];
export { styles as styles };
